module.exports = __webpack_public_path__ + "4ed50070197f5277e6ad6818af55b381.svg";